













import {Vue, Component, Prop} from 'vue-property-decorator'
import {Action} from 'vuex-class'
import Utils from '@/utils'
import {BookRequest, Vehicle} from '@/lib/kepler/interfaces'
import ConfirmDialogCallback from '../ConfirmDialogCallback.vue'

@Component({
  components: {
    ConfirmDialogCallback,
    VehicleConfirmImage: Utils.loadComponent('entities/vehicle/VehicleConfirmImage'),
    TextField: Utils.loadComponent('proxy/Inputs/TextField'),
    Container: Utils.loadComponent('proxy/Container'),
    CloseButton: Utils.loadComponent('CloseButton'),
    CustomIcon: Utils.loadComponent('CustomIcon'),
    Card: Utils.loadComponent('proxy/Card/Card'),
    IsLogged: Utils.loadComponent('IsLogged'),
    Button: Utils.loadComponent('Button'),
  },
  name: 'VehicleBookingAddMemoDialog',
})
export default class VehicleBookingAddMemoDialog extends ConfirmDialogCallback {
  @Action('book') public bookAction!: any
  @Prop() public vehicle!: Vehicle
  @Prop() public bookRequest!: BookRequest
}
